// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"369":"314a8f53db03f80c4416","926":"d0d3c57d9dbedd989fd5","958":"f58218f525cf7976c556"}[chunkId] + ".chunk.js";
};